import { AutomationNodeType } from '@frontend/app/types/globalTypes';
import { NodeCategory, NodeTemplate } from '../types';

export type PlaceholderType = 'else' | 'path' | 'then' | 'default';

/**
 * Creates a placeholder node template with context-specific metadata
 */
export const createPlaceholderNode = (type: PlaceholderType): NodeTemplate => {
  const getDescription = () => {
    switch (type) {
      case 'else':
        return "Creators who don't meet the conditions above will follow this path.";
      case 'then':
        return 'Creators who meet the conditions above will follow this path.';
      case 'path':
        return 'Paths will be executed in parallel.';
      default:
        return 'Choose a block type to continue';
    }
  };

  return {
    type: AutomationNodeType.ACTION,
    subType: undefined,
    category: NodeCategory.PLACEHOLDER,
    displayName: 'Select Block',
    description: getDescription(),
    icon: 'plus',
    defaultMetadata: {
      isPlaceholder: true,
      placeholderType: type
    },
    allowsChildren: true,
  };
};
